import { reduce } from 'lodash'

import { LAST_MESSAGE_AUTHOR_KEY } from '../consts'
import { AdditionalFilterRecord } from '../types'

const FILTERS_KEYS_TO_EXCLUDE = [LAST_MESSAGE_AUTHOR_KEY]

export const calculateSelectedFilters = (filters?: Partial<AdditionalFilterRecord>) => {
  if (!filters) {
    return 0
  }

  let appliedFilters = reduce(
    Object.entries(filters),
    (acc, [key, curr]) => {
      if (FILTERS_KEYS_TO_EXCLUDE.includes(key)) {
        return acc
      }

      return acc + (Array.isArray(curr) ? curr.length : 1)
    },
    0,
  )
  const filterKeys = Object.keys(filters)

  // these two fields are representing one interval filter, so we check they exist but count only one
  if (filterKeys.includes('from') && filterKeys.includes('to')) {
    appliedFilters -= 1
  }

  return appliedFilters
}
